import type { Preset } from '@/model/Preset.model';

export enum PercentChangeOptions {
  fromFirstMeasurement = 'from_first_measurement',
  fromLatestMeasurement = 'from_latest_measurement',
  trackingDate = 'tracking_started_at',
}

export type PercentChangeSettings = Record<Preset['id'], PercentChangeOptions>;
